import { Col, Row, Select } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import { ListVehicleAccessoryQuery } from '@/core/domain/people/Accessory/Accessory.types';
import { useIntl } from 'react-intl';

function AccessoriesExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListVehicleAccessoryQuery>) {
  const intl = useIntl().formatMessage;

  return (
    <Row gutter={[16, 16]} align="middle">
      <Col xs={24} sm={24} md={8} xl={4}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>

      <Col xs={24} sm={24} md={8} xl={4}>
        <Select
          allowClear
          defaultValue={queryParams?.checkList}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, checkList: value }))
          }
          style={{ width: '100%' }}
          placeholder="Checklist"
        >
          <Select.Option value={true}>
            {intl({ id: 'commons.options.yes' })}
          </Select.Option>
          <Select.Option value={false}>
            {intl({ id: 'commons.options.no' })}
          </Select.Option>
        </Select>
      </Col>

      <Col xs={24} sm={24} md={8} xl={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default AccessoriesExtraFilters;
